/* export const baseUrl = "http://192.168.1.10:8000/api/v1"; */
export const baseUrl = "http://192.168.1.6:3000/";
export const imageUrl = "http://192.18.1.16:3000/static/media/";
